<script>
    import {writable, get} from 'svelte/store';
    import ConfirmBooking from "./ConfirmBooking.svelte";
    import {navigate} from "svelte-routing";
    import {createEventDispatcher} from "svelte";
    import {onMount} from "svelte";

    let localDate = new Date();
    let currentDate = writable(new Date(Date.UTC(localDate.getFullYear(), localDate.getMonth(), localDate.getDate())));
    let availableHours = writable(new Set());
    let selectedDate = writable(null);
    let selectedHour = writable(null);
    let confirmButton = writable(false);
    let nome = '';
    let telefono = null;
    let email = '';
    let inputsFilled = writable(false);
    let appointmentConfirmed = writable(false);
    let availableDays = writable(new Set());
    const dispatch = createEventDispatcher();
    export let selectedServices;



    function goBack() {
        dispatch('back');
    }

    function checkInputs() {
        if (nome.length > 0 && telefono !== null && telefono.toString().length > 0 && email.length > 0) {
            inputsFilled.set(true);
        } else {
            inputsFilled.set(false);
        }
    }

    function selectDate(date) {
        selectedDate.set(date);
        getAvailableHours();
    }

    function selectHour(hour) {
        selectedHour.set(hour);
    }

    function nextMonth() {
        currentDate.update(current => {
            selectedDate.set(null);
            selectedHour.set(null);
            return new Date(Date.UTC(current.getUTCFullYear(), current.getUTCMonth() + 1, 1));
        });
        getAvailableDays();
    }

    function prevMonth() {
        currentDate.update(current => {
            selectedDate.set(null);
            selectedHour.set(null);
            return new Date(Date.UTC(current.getUTCFullYear(), current.getUTCMonth() - 1, 1));
        });
        getAvailableDays();
    }

    function getDaysInMonth(date) {
        return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1, 0)).getUTCDate();
    }

    function getStartingDayOfMonth(date) {
        let startingDay = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), 1)).getUTCDay();
        return startingDay === 0 ? 6 : startingDay - 1;
    }

    function saveToLocalStorage() {
        localStorage.setItem('selectedDate', JSON.stringify(get(selectedDate)));
        localStorage.setItem('selectedHour', JSON.stringify(get(selectedHour)));
        localStorage.setItem('nome', nome);
        localStorage.setItem('telefono', telefono);
        localStorage.setItem('email', email);
    }

    async function getAvailableDays() {
        let response = await fetch('/api/open-days?' + new URLSearchParams({
            month: $currentDate.getUTCMonth() + 1,
            year: $currentDate.getUTCFullYear(),
            duration: localStorage.getItem('durationMinutesCount')
        }));
        if (response.status !== 200) {
            $availableDays = new Set();
            return;
        }
        $availableDays = new Set(await response.json());
    }

    // ?<year>&<month>&<day>&<duration> open-slots?<year>&<month>&<day>&<duration>
    async function getAvailableHours() {
        let response = await fetch('/api/open-slots?' + new URLSearchParams({
            month: $selectedDate.getUTCMonth() + 1,
            year: $selectedDate.getUTCFullYear(),
            day: $selectedDate.getUTCDate(),
            duration: localStorage.getItem('durationMinutesCount')
        }));
        if (response.status !== 200) {
            $availableDays = new Set();
            return;
        }
        const data = await response.json();
        availableHours.set(new Set(data));
    }

    async function confirmBooking() {
        let response = await fetch('/api/book', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                month: $selectedDate.getUTCMonth() + 1,
                year: $selectedDate.getUTCFullYear(),
                day: $selectedDate.getUTCDate(),
                hour: parseInt(localStorage.getItem('selectedHour').substring(1, 3)),
                duration: parseInt(localStorage.getItem('durationMinutesCount')),
                service_list: Array.from($selectedServices),
                customer_name: localStorage.getItem('nome'),
                customer_phone: localStorage.getItem('telefono'),
                customer_email: localStorage.getItem('email')
            })
        });
        console.log(response.url);
        if (response.status !== 200) {
            $availableDays = new Set();
            return;
        }
        localStorage.clear();
        selectedServices.set(new Set());
    }

    function getMonthName(utcDay){
        let date = new Date(utcDay.getUTCFullYear(), utcDay.getUTCMonth(), utcDay.getUTCDate());
        return date.toLocaleDateString('it-IT', {month: 'long'});
    }

    onMount(() => {
        getAvailableDays();
    });
</script>

<style>
    .dat-div-back {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 10px;
        border-radius: 10px;
        user-select: none;
    }

    .dat-div {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
        padding: 20px;
        border-radius: 10px;
    }

    .icon {
        width: 35px;
        height: 35px;
    }

    .calendar {
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        gap: 5px;
        user-select: none;
    }

    .day {
        padding: 10px;
        border: 1px solid #ccc;
        cursor: pointer;
        text-align: center;
    }

    .day:hover {
        background-color: #f0f0f0;
    }

    .hour {
        padding: 10px;
        border: 1px solid #ccc;
        cursor: pointer;
        text-align: center;
    }

    .hour:hover {
        background-color: #f0f0f0;
    }

    .selected {
        background-color: #eca8ca;
    }

    .selected:hover {
        background-color: #eca8ca;
    }

    .nav-buttons {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        align-items: center;
    }

    .default-button {
        background: #8ba3f2;
        background: #eca8ca;
        border: 1px solid #eca8ca;
        border-radius: 6px;
        box-shadow: rgba(0, 0, 0, 0.1) 1px 2px 4px;
        box-sizing: border-box;
        color: #FFFFFF;
        cursor: pointer;
        display: inline-block;
        font-size: 16px;
        font-weight: 600;
        outline: 0;
        text-align: center;
        text-rendering: geometricprecision;
        text-transform: none;
        user-select: none;
        -webkit-user-select: none;
        touch-action: manipulation;
        vertical-align: middle;
        width: auto;
        margin: 0;
    }

    .default-button:hover,
    .default-button:active {
        background-color: white;
        background-position: 0 0;
        color: #eca8ca;
    }

    .default-button:active {
        opacity: .5;
    }

    .disabled {
        color: gray;
        cursor: not-allowed;
    }

    .other-month {
        border: 1px solid white;
    }

    .other-month:hover {
        background-color: #fff;
        cursor: default;
    }

    .day-name:hover {
        background-color: #fff;
        cursor: default;
    }

    .day-name {
        border: unset;
        border-bottom: 1px solid;
        margin-bottom: 15px;
    }

    .span-hours {
        text-align: center;
        margin-top: 50px;
        font-weight: bold;
        font-size: 20px;
    }

    .dat-div-span {
        margin-top: 50px;
        text-align: center;
    }

    .coolinput {
        display: flex;
        flex-direction: column;
        width: fit-content;
        position: static;
        max-width: 300px;
    }

    .coolinput label.text {
        font-size: 1rem;
        color: #eca8ca;
        font-weight: 700;
        position: relative;
        top: 0.5rem;
        margin: 0 0 0 7px;
        padding: 0 3px;
        background: white;
        width: fit-content;
    }

    .coolinput input.input {
        padding: 11px 10px;
        font-size: 1rem;
        border: 2px #eca8ca solid;
        border-radius: 5px;
        background: white;
    }

    .coolinput input.input:focus {
        outline: none;
    }

    .hours {
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        gap: 5px;
        user-select: none;
        font-size: 12px;
    }

    .dat-div-inputs {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }

    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input[type="number"] {
        -moz-appearance: textfield; /* Firefox */
    }

    .back-button {
        background: #ffffff;
        border: 1px solid #b2b2b2;
        border-radius: 6px;
        box-shadow: rgba(0, 0, 0, 0.1) 1px 2px 4px;
        box-sizing: border-box;
        color: #000000;
        cursor: pointer;
        display: inline-block;
        font-size: 16px;
        font-weight: 600;
        line-height: 30px;
        min-height: 40px;
        outline: 0;
        padding: 14px 5px;
        text-align: center;
        text-rendering: geometricprecision;
        text-transform: none;
        user-select: none;
        -webkit-user-select: none;
        touch-action: manipulation;
        vertical-align: middle;
        width: 200px;
    }

    .back-button:active {
        background-color: white;
        background-position: 0 0;
        color: black;
        opacity: .5;
    }

    @media (max-width: 768px) {
        .back-button {
            width: 50vw;
        }

        .calendar {
            grid-template-columns: repeat(7, 1fr);
            gap: 5px;
            user-select: none;
            font-size: 12px;
        }

        .hours {
            grid-template-columns: repeat(5, 1fr);
        }

        .coolinput {
            max-width: 80%;
        }
    }
</style>

{#if !($confirmButton) }
    <div class="dat-div-back">
        <button class="back-button" on:click={goBack}>Indietro</button>
    </div>
    <div class="dat-div">
        <img class="icon" src="./icons/calendar.png" alt="calendar">
        <span style="margin-left:10px; font-size:22px;">Seleziona la data e l'ora</span>
    </div>

    {#if true}
        <div class="nav-buttons">
            <button class="default-button" style="width: 50px; height: 50px;" on:click={prevMonth}>&lt;</button>
            <span style="font-size:20px; font-weight: bold; text-transform: capitalize;">{getMonthName($currentDate)} {$currentDate.getUTCFullYear()}</span>
            <button class="default-button" style="width: 50px; height: 50px;" on:click={nextMonth}>&gt;</button>
        </div>

        <div class="calendar">
            {#each ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'] as day}
                <div class="day day-name">
                    {day}
                </div>
            {/each}

            {#each Array.from({length: getStartingDayOfMonth($currentDate)}, (_, i) => i) as prevDay}
                <div class="day other-month"></div>
            {/each}

            {#each Array.from({length: getDaysInMonth($currentDate)}, (_, i) => i + 1) as day}
                {#if $selectedDate && (day === $selectedDate.getUTCDate())}
                    <div class="day selected" on:click={() => {
                        let date = new Date();
                        date.setUTCFullYear($currentDate.getUTCFullYear());
                        date.setUTCMonth($currentDate.getUTCMonth());
                        date.setUTCDate(day); console.log(day);
                    }}>
                        {day}
                    </div>
                {:else if (!$availableDays.has(new Date(Date.UTC($currentDate.getUTCFullYear(), $currentDate.getUTCMonth(), day)).toISOString().substring(0, 10)))}
                    <div class="day other-month disabled">
                        {day}
                    </div>
                {:else}
                    <div class="day" on:click={() => {
                        let date = new Date();
                        date.setUTCFullYear($currentDate.getUTCFullYear());
                        date.setUTCMonth($currentDate.getUTCMonth());
                        date.setUTCDate(day);
                        console.log(day);
                        selectDate(date);
                    }}>
                        {day}
                    </div>
                {/if}
            {/each}
        </div>

        {#if $selectedDate && typeof $selectedDate === 'object'}
            <div class="dat-div-span">
                <span class="span-hours">Orari disponibili per {$selectedDate.getUTCDate()} {getMonthName($selectedDate)}</span>
                <div class="hours" style="margin-top: 20px;">
                    {#each [...$availableHours] as hour}
                        <div class="hour {$selectedHour === hour ? 'selected' : ''}"
                             on:click={() => selectHour(hour)}>{hour}</div>
                    {/each}
                </div>
            </div>
        {/if}
        {#if $selectedHour !== null}
            <div style="display:flex; align-items: center; justify-content: center;">
                <div class="default-button" style="padding: 10px 20px; margin-top:30px;"
                     on:click={() => { confirmButton.set(true) }}>Ulteriore
                </div>
            </div>
        {/if}
    {/if}
{/if}

{#if $confirmButton && !$appointmentConfirmed}
    <div class="dat-div-back">
        <button class="back-button" on:click={() => confirmButton.set(false)}>Indietro</button>
    </div>
    <div class="dat-div">
        <img class="icon" src="./icons/client.png" alt="calendar">
        <span style="margin-left:10px; font-size:22px;">Informazioni sui contatti</span>
    </div>
    <div class="dat-div-inputs">
        <div class="coolinput">
            <label for="input" class="text">Nome</label>
            <input type="text" bind:value={nome} name="input" class="input" on:input={checkInputs}>
        </div>
        <div class="coolinput">
            <label for="input" class="text">Numero di telefono</label>
            <input type="number" bind:value={telefono} name="input" class="input" inputmode="numeric"
                   on:input={checkInputs}>
        </div>
        <div class="coolinput">
            <label for="input" class="text">Email</label>
            <input type="text" bind:value={email} name="input" class="input" on:input={checkInputs}>
        </div>
        {#if $inputsFilled}
            <div style="display:flex; align-items: center; justify-content: center;">
                <div class="default-button" style="padding: 10px 20px; margin-top:30px;"
                     on:click={() => {saveToLocalStorage(); appointmentConfirmed.set(true);confirmBooking()}}>Confermare
                </div>
            </div>
        {/if}
    </div>
{/if}

{#if $appointmentConfirmed}
    <ConfirmBooking/>
    <div class="dat-div-back">
        <button class="back-button"
                on:click={() => {navigate("/"); confirmButton.set(false); appointmentConfirmed.set(false);}}>Pagina
            Iniziale
        </button>
    </div>
{/if}